import { Inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ChangeFlightConfirmationService } from './change-flight-confirmation.service';
import { SelectedFlightResponse } from './_interfaces_/change-flight-confirmation.interface';


@Injectable({
  providedIn: 'root',
})

export class ChangeFlightConfirmationResolver implements Resolve<SelectedFlightResponse> {
  constructor(
    @Inject(ChangeFlightConfirmationService) private _changeFlightConfirmationService: ChangeFlightConfirmationService,
  ) {}

  resolve(): Observable<SelectedFlightResponse> {
    return this._changeFlightConfirmationService.getSelectedFlightResponse();
  }
}
